/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CidData
 */
export interface CidData {
    /**
     * 
     * @type {object}
     * @memberof CidData
     */
    collectibles?: object;
    /**
     * 
     * @type {object}
     * @memberof CidData
     */
    associatedSolWallets?: object;
    /**
     * 
     * @type {object}
     * @memberof CidData
     */
    associatedWallets?: object;
}

/**
 * Check if a given object implements the CidData interface.
 */
export function instanceOfCidData(value: object): value is CidData {
    let isInstance = true;

    return isInstance;
}

export function CidDataFromJSON(json: any): CidData {
    return CidDataFromJSONTyped(json, false);
}

export function CidDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CidData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'collectibles': !exists(json, 'collectibles') ? undefined : json['collectibles'],
        'associatedSolWallets': !exists(json, 'associated_sol_wallets') ? undefined : json['associated_sol_wallets'],
        'associatedWallets': !exists(json, 'associated_wallets') ? undefined : json['associated_wallets'],
    };
}

export function CidDataToJSON(value?: CidData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'collectibles': value.collectibles,
        'associated_sol_wallets': value.associatedSolWallets,
        'associated_wallets': value.associatedWallets,
    };
}

